import React, { useState, useRef, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  // loginUser,
  // getLogedUser,
  setIsLogin,
  setUserPermissionData,
  addLoginUser,
} from "../../actions/Users";
import { Redirect, Link, useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { axiosNewInstance, encryption_salt } from "../../config/Api";
import BreadCrumbs from "../page/BreadCrumbs";
import InnerHTML from "dangerously-set-inner-html";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";
// import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
// const Login = ({setIsLogin, getLogedUser, loginUser, lang}) => {
const Login = ({ setIsLogin, lang }) => {
  const history = useHistory();
  const location = useLocation();
  const [validator, setValidator] = useState({});
  const [mobileNo, setMobileno] = useState("");
  const [otp, setOtp] = useState({});
  const [disLogin, setDisLogin] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [allowLogin, setAllowLogin] = useState(false);
  const [formType, setFormType] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [verifyDisabled, setVerifyDisabled] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [timer, setTimer] = useState(0);
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const forgotUserCookiesHeader = window.btoa(
      "ForgotUserName" + encryption_salt
    );
    const cookiesForgotUser = Cookies.get(forgotUserCookiesHeader);
    if (cookiesForgotUser) {
      Cookies.remove(cookiesForgotUser);
    }
  }, []);
  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setResendDisabled(false);
      setVerifyDisabled(true);
    }

    return () => clearInterval(countdown);
  }, [timer]);

  useEffect(() => {
    if (usernameRef?.current?.value || passwordRef?.current?.value) {
      setDisLogin(false);
    }
  }, [usernameRef?.current?.value, passwordRef?.current?.value]);

  const handleLogin = () => {
    setDisLogin(true);
    let userFormData = {};
    let validation = {};

    if (formType === "office") {
      userFormData = {
        user_id: usernameRef.current.value,
        password: passwordRef.current.value,
      };
      if (!userFormData.user_id) validation.username = "Username is required";
      if (!userFormData.password) validation.password = "Password is required";
    } else if (formType === "policyHolder") {
      userFormData = { mobile_no: mobileNo };

      if (!mobileNo) {
        validation.username = "Phone number is required";
      } else if (!/^\d{11}$/.test(mobileNo)) {
        validation.username = "Phone number must be 11 digits";
      }
    } else if (formType === "otp") {
      userFormData = { customer_id: otp?.customerId, otp: otp?.value };
      if (!otp?.value) validation.username = "Otp is required";
    }

    if (Object.keys(validation).length) {
      setValidator(validation);
      setMessage("");
      return;
    }

    if (formType === "office") {
      officeLogin(userFormData);
    } else if (formType === "policyHolder") {
      policyHolderLogin(userFormData);
    } else if (formType === "otp") {
      otpLogin(userFormData);
    }
  };
  // const user = useSelector((state) => state?.user);

  const officeLogin = (userData) => {
    axiosNewInstance
      .post("/api-app/user-login", userData)
      .then((response) => {
        const token = response.data.token.token;
        localStorage.setItem("authToken", token);
        setMessageType("success");
        setValidator({});
        setAllowLogin(true);
        dispatch(setIsLogin(true));
        dispatch(setUserPermissionData(response.data.token?.permissions));

        const loggedInUser = response.data.token?.user;
        dispatch(addLoginUser(loggedInUser));


        // Check if preClicked is set to 'pay_lic_bill'
        const preClicked = localStorage.getItem("preClicked");

        // If pay_lic_bill is yes, redirect to the homepage and open the popup
        if (preClicked === "pay_lic_bill") {
          history.push('/');
        } else {
          if (loggedInUser?.reset_password === 0) {
            history.push("/reset-password");
          } else {
            const redirectUrl =
              location?.state?.from ||
              (new URLSearchParams(location.search)).get("redirect") ||
              "/dashboard_admin";
            history.push(redirectUrl);
          }
        }
      })
      .catch(handleLoginError);
  };

  const policyHolderLogin = (userData) => {
    setResendDisabled(true);
    setVerifyDisabled(false);
    axiosNewInstance
      .post("/api-app/customer-login", userData)
      .then((response) => {
        if (response?.data?.status === 1) {
          setOtp({
            ...otp,
            allowOtp: true,
            customerId: response?.data?.data?.customer_id,
          });
          setFormType("otp");
          // setResendDisabled(true);
          // setVerifyDisabled(false);
          setTimer(180);
          setDisLogin(false);
          toast.success(response?.data?.message);
        } else {
          // console.log("response data message 3333333333", response?.data, response)
          setResendDisabled(false);
          setVerifyDisabled(true);
          setOtp({ ...otp, allowOtp: false });
          toast.error(response?.data?.message);
        }
      })
      .catch(handleLoginError);
  };
  const handleResendOtp = () => {
    setResendDisabled(true);
    setVerifyDisabled(false);
    axiosNewInstance
      .post("/api-app/resend-otp", { customer_id: otp?.customerId })
      .then((response) => {
        if (response?.data?.status === 1) {
          // setResendDisabled(true);
          // setVerifyDisabled(false);
          setTimer(180);
          toast.success(`${response?.data?.message}`);
        } else {
          setResendDisabled(false);
          setVerifyDisabled(true);
          // setAllowOtpBox(false);
          // setOtp({ ...otp, allowOtp: false });
          toast.error(`${response?.data?.message}`);
        }
      })
      .catch((error) => {
        console.log("error", error);
        handleLoginError(error);
      });
  };
  const otpLogin = (userData) => {
    axiosNewInstance
      .post("/api-app/match-otp", userData)
      .then((response) => {
        console.log("check 3333333333333333333333333", response, response.data);
        if (response?.data?.status === 1) {
          const token = response.data?.data?.token;
          localStorage.setItem("authToken", token);
          setMessageType("success");
          setValidator({});
          setAllowLogin(true);
          setDisLogin(false);
          dispatch(setIsLogin(true));
          dispatch(setUserPermissionData([]));
          dispatch(
            addLoginUser({
              ...response.data?.data?.customer,
              user_type: response?.data?.data?.user_type,
            })
          );

          toast.success(response?.data?.message);

          // Check if preClicked is set to 'pay_lic_bill'
          const preClicked = localStorage.getItem("preClicked");

          // If pay_lic_bill is yes, redirect to the homepage and open the popup
          if (preClicked === "pay_lic_bill") {
            history.push('/');  // Redirect to the homepage
          } else {
            const redirectUrl =
              location?.state?.from ||
              (new URLSearchParams(location.search)).get("redirect") ||
              "/dashboard_admin";
            history.push(redirectUrl);
          }
          
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch(handleLoginError);
  };

  const handleLoginError = (error) => {
    setDisLogin(false);
    setResendDisabled(false);
    toast.error(error.response?.data?.message);
    setMessageType("danger");
    setValidator({});
  };

  if (allowLogin) return <Redirect to="dashboard_admin" />;

  const breadCrumbs = [
    { bn_title: "লগ ইন", title: "Sign In", url: "/login" },
    { bn_title: "হোম", title: "Home", url: "/" },
  ];

  console.log("log for timer 3333333333", resendDisabled, verifyDisabled, otp);
  return (
    <>
      <BreadCrumbs bread_curmbs={breadCrumbs} />
      <section className="sign-up">
        <div className="container">
          {!formVisible ? (
            <div className="card custom-card mx-auto mb-4 text-center">
              <div className="card-body">
                <button
                  className="btn btn-primary mb-5 mt-5 w-75 mx-auto"
                  style={{ backgroundColor: "#004E8F", padding: "8px 25px" }}
                  onClick={() => {
                    setFormType("office");
                    setFormVisible(true);
                  }}
                >
                  {lang === "en" ? "Office" : "অফিস"}
                </button>
                <button
                  className="btn btn-primary w-75 mb-5 mx-auto"
                  style={{ backgroundColor: "#004E8F", padding: "8px 25px" }}
                  onClick={() => {
                    setFormType("policyHolder");
                    setFormVisible(true);
                  }}
                >
                  {lang === "en" ? "Policy Holder" : "পলিসি হোল্ডার"}
                </button>
              </div>
            </div>
          ) : (
            <form>
              {message && (
                <div className="col-sm-12" style={{ marginTop: "10px" }}>
                  <div
                    className={`alert alert-${messageType} alert-dismissible fade show`}
                    role="alert"
                  >
                    <InnerHTML html={message} />
                    <button
                      type="button"
                      className="close"
                      onClick={() => setMessage("")}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}

              <h3>{lang === "en" ? "Log In" : "লগ ইন"}</h3>

              {formType === "office" ? (
                <>
                  <div className="row">
                    <div className="col-md-12" style={{ marginBottom: "30px" }}>
                      <input
                        type="text"
                        placeholder="User name"
                        ref={usernameRef}
                        className="form-control"
                        required
                        autoFocus
                      />
                      {validator.username && (
                        <span className="help-block form-text text-danger">
                          {validator.username}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          ref={passwordRef}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="form-control mb-4"
                          required
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-light mb-4 border"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                      </div>
                      {validator.password && (
                        <span className="help-block form-text text-danger">
                          {validator.password}
                        </span>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {otp?.allowOtp ? (
                    <>
                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{ marginBottom: "30px" }}
                        >
                          <input
                            type="number"
                            placeholder="Enter your OTP"
                            value={otp?.value ?? ""}
                            onChange={(e) =>
                              setOtp({ ...otp, value: e.target.value })
                            }
                            className="form-control"
                            required
                          />
                          {validator.username && (
                            <span className="help-block form-text text-danger">
                              {validator.username}
                            </span>
                          )}
                        </div>
                        <div className="col-md-12">
                          <button
                            type="button"
                            className="btn btn-secondary btn-block"
                            style={{
                              cursor: resendDisabled
                                ? "not-allowed"
                                : "pointer",
                              opacity: resendDisabled ? 0.6 : 1,
                            }}
                            onClick={handleResendOtp}
                            disabled={resendDisabled}
                          >
                            {resendDisabled
                              ? `Resend OTP in ${timer}s`
                              : "Resend OTP"}
                          </button>
                        </div>
                        <div className="col-md-12 mt-3">
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={handleLogin}
                            style={{
                              cursor: !resendDisabled
                                ? "not-allowed"
                                : "pointer",
                              opacity: !resendDisabled ? 0.6 : 1,
                            }}
                            // disabled={!verifyDisabled}
                            disabled={!resendDisabled}
                          >
                            Verify
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{ marginBottom: "30px" }}
                        >
                          <input
                            type="text"
                            value={mobileNo}
                            placeholder="Enter your number"
                            onChange={(e) => setMobileno(e.target.value)}
                            className="form-control"
                            required
                          />
                          {validator.username && (
                            <span className="help-block form-text text-danger">
                              {validator.username}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
              {!otp?.allowOtp && (
                <div className="col-md-12 p-0">
                  <div className="row g-0">
                    <div className="col-6 pr-1">
                      <button
                        type="button"
                        className="btn btn-secondary w-100"
                        onClick={() => setFormVisible(false)}
                      >
                        Back
                      </button>
                    </div>
                    <div className="col-6 p-0">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleLogin}
                        disabled={disLogin}
                        style={{
                          cursor: disLogin ? "not-allowed" : "pointer",
                          opacity: resendDisabled ? 0.6 : 1,
                        }}
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </form>
          )}
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  lang: state.utils.lang,
});

const mapDispatchToProps = (dispatch) => ({
  // loginUser: (requestData) => dispatch(loginUser(requestData)),
  // getLogedUser: (requestData) => dispatch(getLogedUser(requestData)),
  setIsLogin: (requestData) => dispatch(setIsLogin(requestData)),
  setUserPermissionData: (requestData) =>
    dispatch(setUserPermissionData(requestData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
